export default {
    'Text field': 'Campo de Texto',
    'Text area': 'Área de texto',
    'Number': 'Número',
    'Date time': 'Fecha',
    'Expression': 'Expresión',
    'Components': 'Componentes',
    'Checkbox': 'Casilla Verificacion',
    'Checkbox group': 'Casillas Verificacion',
    '': '',
    'Select': 'Menú Desplegable',
    'Tag list': 'Lista etiquetas',
    'Text view': 'Texto',
    'Image view': 'Imagen',
    'Table': 'Tabla',
    'HTML view': 'Vista HTML',
    'Spacer': 'Espacio',
    'Separator': 'Separador',
    'Group': 'Grupo',
    'Dynamic list': 'Lista Dinámica',
    'Button': 'Botón',
    'Selection': 'Selección',
    'Presentation': 'Presentación',
    'Containers': 'Contenedores',
    'Action': 'Acción',
    'Search components': 'Buscar componentes',
    'Build your form': 'Construye tu formulario',
    'Drag and drop components here to start designing.': 'Arrastra y suelta componentes aquí para comenzar a diseñar.', 
    'Use the preview window to test your form.': 'Utiliza la ventana de vista previa para probar tu formulario.',
    'Condition': 'Condición',
    'Field label': 'Etiqueta',
    'Field description': 'Descripción',
    'Key': 'Llave',
    'Default value': 'Valor por Defecto',
    'Hide if': 'Esconder si',
    'Binds to a form variable': 'Se une a una variable de formulario',
    'Condition under which the field is hidden': 'Condición bajo la cual el campo está oculto.',
    'Layout': 'Disposición',
    'Columns': 'Columnas',
    'Appearance': 'Apariencia',
    'Prefix': 'Prefijo',
    'Suffix': 'Sufijo',
    'Serialization': 'Serialización',
    'Output as string': 'Salida a texto',
    'Allows arbitrary precision values': 'Permite valores de precisión arbitrarios.',
    'Validation': 'Validación',
    'Required': 'Requerido',
    'Minimum': 'Mínimo',
    'Maximum': 'Máximo',
    'Custom properties': 'Propiedades personalizadas',
    'Create a Text field element': 'Crear Campo de Texto',
    'Create a Text area element': 'Crear Area de Texto',
    'Create a Number element': 'Crear Campo Numérico',
    'Create a Date time element': 'Crear Campo de Fecha',
    'Create a Expression element': 'Crear Campo de Expresión',
    'Create a Checkbox element': 'Crear Campo Casilla de Verificación',
    'Create a Checkbox group element': 'Crear Campo grupo Casilla de Verificación',
    'Create a Radio group element': 'Crear Campo Radio Group',
    'Create a Select element': 'Crear Campo Desplegable',
    'Create a Tag list element': 'Crear Campo Lista etiquetas',
    'Create a Text view element': 'Crear Visualizador Texto',
    'Create an Image view element': 'Crear Visualizador de imagenes',
    'Create a Table element': 'Crear Tabla',
    'Create a HTML view element': 'Crear Visualizador de HTML',
    'Create a Spacer element': 'Crear Espaciador',
    'Create a Separator element': 'Crear Separador',
    'Create a Group element': 'Crear Campo Grupo',
    'Create a Dynamic list element': 'Crear Lista Dinámica',
    'Create a iFrame element': 'Crear IFrame',
    'Create a Button element': 'Crear Botón',
    'Constraints': 'Restricciones',
    'Disallow past dates': 'No permitir fechas pasadas',
    'Static options': 'Opciones estáticas',
    'Options source': 'Origen de las opciones',
    'Value': 'Valor',
    'Type': 'Tipo',
    '"List of items" defines a constant, predefined set of form options.': '"List of items" defines a constant, predefined set of form options.',


};